module.exports = __webpack_public_path__ + "img/left_right_layout_1.2b56875e.svg";